module.exports = __webpack_public_path__ + "img/szallitaskezelo_favi_nyilas_kek_uj.1045f0c2.png";